/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { tableService } from "../../services/tableService";
import LoadingSpinner from "../common/LoadingSpinner";
import ErrorAlert from "../common/ErrorAlert";

const TablesModal = ({ open, onOpenChange, onSelectTable }) => {
  const [tables, setTables] = useState({});
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTables = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await tableService.listTables();

      if (result.success) {
        const groupedTables = tableService.groupTablesByLocation(result.data);
        const uniqueLocations = tableService.getUniqueLocations(result.data);

        setTables(groupedTables);
        setLocations(uniqueLocations);
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Error al cargar las mesas");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchTables();
    }
  }, [open]);

  if (!open) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Seleccionar Mesa</DialogTitle>
        </DialogHeader>

        {isLoading ? (
          <LoadingSpinner />
        ) : error ? (
          <ErrorAlert message={error} onRetry={fetchTables} />
        ) : (
          <Tabs defaultValue={locations[0]} className="w-full">
            <TabsList
              className="grid w-full"
              style={{
                gridTemplateColumns: `repeat(${locations.length}, 1fr)`,
              }}
            >
              {locations.map((location) => (
                <TabsTrigger
                  key={location}
                  value={location}
                  className="data-[state=active]:bg-orange-500 data-[state=active]:text-white"
                >
                  {location}
                </TabsTrigger>
              ))}
            </TabsList>

            {locations.map((location) => (
              <TabsContent key={location} value={location}>
                <div className="grid grid-cols-3 gap-4">
                  {tables[location]?.map((table) => (
                    <button
                      key={table.id}
                      onClick={() => {
                        console.log("Mesa seleccionada (onClick)", table.id);
                        onSelectTable({
                          id: table.id,
                          description: table.descriptionMesa,
                          hasOrders: table.tableStatus === "EN CURSO",
                        });
                        onOpenChange(false);
                      }}
                      className={`
                       p-4 rounded-lg text-center transition-colors
                       ${
                         table.tableStatus === "EN CURSO"
                           ? "bg-orange-500 text-white"
                           : "bg-orange-100 border-2 border-orange-500 text-orange-500"
                       }
                       hover:opacity-90
                     `}
                    >
                      <div>{table.descriptionMesa || `Mesa ${table.id}`}</div>
                      <div className="text-sm mt-1">
                        {table.cantAsientos} asientos
                      </div>
                    </button>
                  ))}
                </div>
              </TabsContent>
            ))}
          </Tabs>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TablesModal;
